import React from 'react';
import type { PolicyDocument } from '../../types/policy';
import { PolicyLayout } from './PolicyLayout';
export function PolicyFromText({
  doc
}: {
  doc: PolicyDocument;
}) {
  return <PolicyLayout title={doc.title} lead={doc.lead} sections={doc.sections} data-id="element-1032" data-mp="1qpd09735x9gu" />;
}